import { loadImage } from "iso-canvas";
import mime from "mime";
import extension from "@local/extensions/utilities/extension.js";
import nameMinusExtension from "@local/extensions/utilities/name-minus-extension.js";
import { api } from "#src/api";
import dataUrlToBase64 from "#src/extensions/data-url-to-base64.js";
import { settingTriopsUrl as triopsUrl } from "#src/stores/ui.js";

let $triopsUrl;
triopsUrl.subscribe((v) => ($triopsUrl = v));

async function locationImage(page) {
  const ext = extension(page.name);

  if (ext === "pdf") {
    const path = encodeURIComponent(
      `${nameMinusExtension(page.name)}.${page.page}.tiff`,
    );
    const url = `${$triopsUrl}/iiif/2/drawings/${path}/full/3000,/0/default.jpg`;
    const img = await fetch(url);
    const buf = await img.arrayBuffer();
    const base64 = btoa(
      new Uint8Array(buf).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        "",
      ),
    );
    return {
      type: "base64",
      media_type: "image/jpeg",
      url,
      data: base64,
      path,
      original_extension: ext,
    };
  } else {
    const res = await api.storage
      .from("documents")
      .createSignedUrl(page.name, 60);
    if (res.error) return null;
    const url = res.data.signedUrl;
    const img = await loadImage(url, { crossOrigin: "anonymous" });
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext("2d");
    if (ctx === null) return null;
    ctx.drawImage(img, 0, 0);
    // See data-url-to-base64.js for why the media type comes from the data
    // URL rather than from `ext`.
    const { data, mediaType } = dataUrlToBase64(canvas.toDataURL());
    return {
      type: "base64",
      media_type: mediaType || mime.getType(ext) || "image/jpeg",
      data,
      url,
      original_extension: ext,
    };
  }
}

export default locationImage;
